function getFileExtension(fileName) {
	const normalized = String(fileName || '');
	const index = normalized.lastIndexOf('.');
	if (index < 0) {
		return '';
	}
	return normalized.slice(index + 1).toLowerCase();
}

function resolveFileTypeMeta(extension) {
	const normalized = String(extension || '').toLowerCase();
	if (['pdf'].includes(normalized)) {
		return { shortLabel: 'PDF', fullLabel: 'PDF', tone: 'danger' };
	}
	if (['xls', 'xlsx', 'csv'].includes(normalized)) {
		return { shortLabel: 'XLS', fullLabel: normalized === 'csv' ? 'CSV' : '表格', tone: 'success' };
	}
	if (['doc', 'docx', 'pages'].includes(normalized)) {
		return { shortLabel: 'DOC', fullLabel: '文档', tone: 'primary' };
	}
	if (['ppt', 'pptx', 'key'].includes(normalized)) {
		return { shortLabel: 'PPT', fullLabel: '演示', tone: 'warning' };
	}
	if (['zip', 'rar', '7z', 'tar', 'gz'].includes(normalized)) {
		return { shortLabel: 'ZIP', fullLabel: '压缩包', tone: 'neutral' };
	}
	if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'].includes(normalized)) {
		return { shortLabel: 'IMG', fullLabel: '图片', tone: 'teal' };
	}
	if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(normalized)) {
		return { shortLabel: 'VID', fullLabel: '视频', tone: 'primary' };
	}
	if (['mp3', 'wav', 'aac', 'flac', 'm4a', '3gp', '3gpp', 'amr'].includes(normalized)) {
		return { shortLabel: 'AUD', fullLabel: '音频', tone: 'teal' };
	}
	if (['txt', 'md', 'json', 'xml', 'html', 'htm', 'js', 'ts', 'vue', 'java', 'py', 'go'].includes(normalized)) {
		return { shortLabel: 'TXT', fullLabel: '文本', tone: 'neutral' };
	}
	return {
		shortLabel: normalized ? normalized.slice(0, 4).toUpperCase() : 'FILE',
		fullLabel: normalized ? normalized.toUpperCase() : '文件',
		tone: 'neutral'
	};
}

export {
	getFileExtension,
	resolveFileTypeMeta
};
